import { createRequestTypes } from '../utils';

export const FETCH_ORDER_ACTIONS = createRequestTypes('orderAction/FETCH_ORDER_ACTIONS');
